import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { cn } from "@/lib/utils"
import { SendInviteForm } from "../forms/send-invite-form"

export function InviteCollaboratorModal({
  open,
  setOpen,
  triggerSlot,
  className,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  triggerSlot: React.ReactNode
  className?: string
}) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{triggerSlot}</DialogTrigger>
      <DialogContent className={cn("flex flex-col gap-6", className)}>
        <DialogHeader>
          <DialogTitle>Invite collaborator</DialogTitle>
        </DialogHeader>
        <SendInviteForm />
      </DialogContent>
    </Dialog>
  )
}
